var map = {
	"./alert.svg": 51258,
	"./arrow-right.svg": 61881,
	"./bell.svg": 837,
	"./graduation.svg": 40087,
	"./money.svg": 51987,
	"./notification.svg": 58607,
	"./question.svg": 46718,
	"./report.svg": 96099,
	"./smile.svg": 92400,
	"./users.svg": 42037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39589;